import React from "react";
import { Card, List } from "antd";

export default function ExpiryList({expiries}){
return(

<Card title="Upcoming Renewals">

<List
  dataSource={expiries}
  locale={{ emptyText: "No upcoming expiries 🎉" }}
  renderItem={(item) => (
    <List.Item>
      <div>
        <div style={{ fontWeight: 500 }}>
          {item.employee_name}
        </div>

        <span style={{ fontSize:12, color: item.days <= 5 ? "red" : "#888" }}>
            {item.label}: {item.days} days
        </span>
      </div>
    </List.Item>
  )}
/>

</Card>

);

}